export const app = {
  Storage: "STORAGE"
} as const

export const movementStatus = {
  DRAFT: "DRAFT",
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
  REJECTED: "REJECTED",
  EXPIRED: "EXPIRED"
} as const

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY || "",
  authDomain: process.env.REACT_APP_AUTH_DOMAIN || "",
  projectId: process.env.REACT_APP_PROJECT_ID || "",
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID || "",
  appId: process.env.REACT_APP_APP_ID || "",
  measurementId: process.env.REACT_APP_MEASUREMENT_ID || ""
}
export const baseURL = process.env.REACT_APP_MODULE_BASE_URL || ""
export const vapidKey = process.env.REACT_APP_VAPID_KEY || ""